import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GET_ONE, DELETE } from 'react-admin';
import Tooltip from '@material-ui/core/Tooltip';
// Use material UI button because Tooltip doesn't work with react-admin Button
import Button from '@material-ui/core/Button';

import dataProvider from '../../dataProvider';


class CancelOrderButton extends Component {
  state = {
    isSubmitting: false,
    offer: null,
  };

  async componentDidMount() {
    // Get offer for this order to check if offer
    const { data } = await dataProvider(GET_ONE, 'offerings', { id: this.props.record.offerId });
    // Ok to call setState in a promise
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ offer: data });
  }

  handleClick = async () => {
    this.setState({ isSubmitting: true });
    const { resource, record, cancelOrder } = this.props;
    cancelOrder(resource, record, {
      onSuccess: () => this.setState({ isSubmitting: false }),
    });
  }

  render() {
    // Pull out props that Button doesn't need
    const { cancelOrder, ...rest } = this.props;
    const { folioPrivatePlacementOrderOid, status } = this.props.record;

    let disabled = true;
    let tooltipTitle = false;
    if (status === 'deleted') {
      disabled = true;
      tooltipTitle = 'Already canceled';
    } else if (folioPrivatePlacementOrderOid) {
      disabled = true;
      tooltipTitle = 'Order submitted to Folio. Cancel in Folio Admin';
    } else if (!this.state.offer) {
      disabled = true;
      tooltipTitle = 'Loading data';
    } else if (this.state.isSubmitting) {
      disabled = true;
      tooltipTitle = 'Canceling offer order';
    } else {
      disabled = false;
      tooltipTitle = 'Cancel offer order';
    }

    return (
      <Tooltip title={tooltipTitle}>
        <Button
          onClick={this.handleClick}
          disabled={disabled}
          color="primary"
          size="small"
          {...rest}
        >
          Cancel Offer Order
        </Button>
      </Tooltip>
    );
  }
}

const cancelOrderAction = (resource, record, meta) => ({
  type: 'CANCEL_OFFER_ORDER',
  payload: {
    data: record,
    resource,
    action: 'cancel-offer-order',
  },
  meta: {
    fetch: DELETE,
    resource,
    refresh: true, // refresh this object
    ...meta,
  },
});


CancelOrderButton.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    folioPrivatePlacementOrderOid: PropTypes.string,
  }).isRequired,
  cancelOrder: PropTypes.func.isRequired,
};

export default connect(null, {
  cancelOrder: cancelOrderAction,
})(CancelOrderButton);



// WEBPACK FOOTER //
// ./src/components/OfferOrder/CancelOrderButton.js